<div class="cf-flex-column">
  <label
    class="ac-form-field-label cf-flex"
    [ngClass]="{ 'ac-form-field-label-disabled': !property.Rules.EnableIf, 'ac-form-field-label-readonly': property.Rules.ReadOnlyIf }"
  >
    <span>{{ propertyType.NameId | translate }}</span>
    <span *ngIf="property.Rules.RequiredIf" class="required-sign"> *</span>
    <span
      *ngIf="propertyType | tooltipTextId"
      class="ac-label-tooltip-container"
      [matTooltip]="propertyType | tooltipTextId | translate"
      [matTooltipPosition]="'above'"
      ><mat-icon class="ac-tooltip-icon help" svgIcon="help_outline"></mat-icon
    ></span>
  </label>
  <mat-form-field appearance="outline" [attr.data-test]="property.Key" subscriptSizing="dynamic">
    <mat-select [formControl]="propertyForm" floatLabel="auto" [placeholder]="placeholder">
      <mat-option
        *ngFor="let propertyItem of orderTranslate ? (property.Items | orderTranslate) : property.Items"
        [value]="propertyItem.Value"
      >
        {{ propertyItem.NameId ? (propertyItem.NameId | translate) : propertyItem.Name ? propertyItem.Name : propertyItem.Value }}
        <ng-container *ngIf="measurementUnit$ | async as unit">{{ unit ? (unit.TextId | translate) : '' }}</ng-container>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="ac-form-field-message-error">
    <mat-error *ngIf="propertyForm.errors && propertyForm.errors['required']" translate> UI.Common.Validation.ValueRequired </mat-error>
  </div>
  <div *ngFor="let message of messages">
    <div
      [ngClass]="{
        'ac-form-field-message-error': message.Properties['Level']?.Value === 0,
        'ac-form-field-message-warning': message.Properties['Level']?.Value === 1,
        'ac-form-field-message-info': message.Properties['Level']?.Value === 2
      }"
    >
      {{ message.Properties['Text']?.Value || (message.Properties['TextId']?.Value | translate) }}
    </div>
  </div>
</div>
